import { useSyncExternalStore } from 'react';

/**
 * 입력 장치가 **호버 가능**한지 — `(hover: hover)` (마우스·트랙패드=true / 터치=false).
 * 너비(`useIsCompact`)와 **직교** — 태블릿 PC 는 wide(≥1024)여도 터치라 호버가 없다. 따라서
 * "호버 어포던스" 분기(예: scrollbar `'hover'` vs `'scroll'`)는 너비가 아니라 이 훅으로 판단해야 한다.
 */
const QUERY = '(hover: hover)';

function subscribe(callback: () => void): () => void {
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

/**
 * 호버 가능 입력 여부. `useSyncExternalStore` 로 matchMedia 구독 — SSR 스냅샷=false(호버 없음 가정 →
 * 터치 친화 기본값으로 폴백). 하이브리드(터치+트랙패드 노트북)는 primary 입력이 트랙패드라 true.
 */
export function useCanHover(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false,
  );
}
